import Component from 'can/component/component';
import template from './sideline-games.stache';
import dtm from 'scripts/services/dtm';

const SIDELINE_GAMES_KEY = 'sidelineGamesToken';
const { riskItUrl, pick3Url, tokenUrl } = window.globalSettings.sidelineGames;

Component.extend({
    tag: 'sideline-games',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            fetching: {
                type: 'boolean',
                value: false,
            },
            disabled: {
                get() {
                    return !this.attr('email').length;
                },
            },
            token: {
                type: 'string',
                value: localStorage.getItem(SIDELINE_GAMES_KEY),
            },
            currentUrl: {
                type: 'string',
            },
            email: {
                type: 'string',
                value: '',
            },
            emailVisible: {
                get() {
                    return this.attr('currentUrl') && !this.attr('token');
                },
            },
        },
        setEmail(value) {
            this.attr('email', value);
        },
        handleRiskIt() {
            dtm.trackPickemGameClick('Risk It');
            this.attr('currentUrl', riskItUrl);

            const token = this.attr('token');

            if (token) {
                this.openGamePage(token);
            }
        },
        handlePick3() {
            dtm.trackPickemGameClick('Pick 3');
            this.attr('currentUrl', pick3Url);

            const token = this.attr('token');

            if (token) {
                this.openGamePage(token);
            }
        },
        openGamePage(token) {
            this.attr('fetching', true);
            const currentUrl = this.currentUrl;

            window.open(
                `${currentUrl}?userId=${token}&sideline=internal`,
                '_self',
            );
        },
    },
    events: {
        'form submit'(_element, event) {
            event.preventDefault();

            this.viewModel.attr('fetching', true);

            $.ajax(tokenUrl, {
                data: JSON.stringify({
                    email: this.viewModel.attr('email'),
                }),
                type: 'POST',
                processData: false,
                contentType: 'application/json',
                success: (json) => {
                    const { token } = JSON.parse(json);

                    localStorage.setItem(SIDELINE_GAMES_KEY, token);

                    this.viewModel.openGamePage(token);
                },
            });
        },
    },
});
